import RiInformationFill from '@ben/icons/information-fill';
import RIcon from '@ben/orion/remix-icon';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useTranslation } from 'react-i18next';
import styled, { css, useTheme } from 'styled-components';

const ConditionalApprovalInfo = () => {
  const theme = useTheme();

  const { t } = useTranslation();

  return (
    <InfoContainer>
      <RIcon icon={RiInformationFill} color={theme.palette.primary.main} />
      <Typography variant={TypographyVariant.bodySm2}>
        {t('benefit.conditionalApprovalMessage')}
      </Typography>
    </InfoContainer>
  );
};

export default ConditionalApprovalInfo;

const InfoContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(0.5)};
    width: 100%;
    align-items: center;
  `}
`;
